import { ajax, encodePathVariable } from 'cadenza/api-client/api';
import { MIMETYPE_DISY_HTML_FRAGMENT, PARAMETER_CONDITION_HASH } from 'cadenza/api-client/api-constants';

export class FilterPanelApi {

  /**
   * Returns html content of filter panel for a dashlet.
   *
   * @param conditionSetId - ConditionSetId of a dashlet.
   * @param parameterConditionHash - Value of ConditionHash parameter
   * @param hierarchyParameters - Hierarchies parameters
   * @param [olap=true] - flag to enable/disable hierarchies (overrides the selector setting)
   * @return Promise containing DocumentFragment with the filter panel
   */
  static getContent (
    conditionSetId: string,
    parameterConditionHash: string,
    hierarchyParameters: Map<string, string>,
    olap = true): Promise<DocumentFragment> {
    return this._getPartialFilterPanel(parameterConditionHash, olap, hierarchyParameters, conditionSetId)
      .then(this._buildFilterPanel);
  }

  /* @see net/disy/cadenza/selector/web/rest/FilterViewEndpointController.java */
  static _getPartialFilterPanel (
    parameterConditionHash: string,
    olap: boolean,
    hierarchyParameters: Map<string, string>,
    conditionSetId: string) {
    const params = new URLSearchParams({
      [PARAMETER_CONDITION_HASH]: parameterConditionHash,
      olap: String(olap)
    });
    Object.entries(hierarchyParameters)
      .forEach(entry => params.set(...entry));
    const encodedConditionSetId = encodePathVariable(conditionSetId);
    return ajax<string>(`/conditionsets/${encodedConditionSetId}?${params}`,
      {
        headers: {
          Accept: MIMETYPE_DISY_HTML_FRAGMENT
        }
      });
  }

  static _buildFilterPanel (panelContentHtml: string) {
    const panelDocument = new DOMParser().parseFromString(String(panelContentHtml), 'text/html');
    // ! we know the child is guaranteed to exist because we control the HTML created
    const panelElement = panelDocument.body.firstChild!;
    const panelDocumentFragment = document.createDocumentFragment();
    panelDocumentFragment.appendChild(panelElement);
    return panelDocumentFragment;
  }

}
